import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import {
  salesDeliveryItemsGetAction,
  salesReturnViewAction,
} from "../../../redux/actions/sales-action";
import CreateEditViewSalesRet from "../../../components/sales-section/sales-return/create-edit-view-sales-ret";

const AddSalesReturn = () => {
  const { itemId, type } = useParams();
  const [searchParams] = useSearchParams();

  const itemIdArray = JSON.parse(decodeURIComponent(itemId));

  //
  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;
  //
  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isClone) {
      setLoading(true);
      dispatch(salesReturnViewAction(cloneID, onCloneSuccPur, onErrPur));
    } else if (type === "delivery") {
      setLoading(true);
      dispatch(salesDeliveryItemsGetAction(allitems, onSuccPur, onErrPur));
    }
  }, []);

  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };
  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };
  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};
  const prefix = searchParams.get("type") || "sodtt";
  const isNew = searchParams.has("new");
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          title={`${isClone ? "Clone" : "Add"} Sales Return`}
        >
          <CreateEditViewSalesRet
            clickedplus={isNew}
            isClone={isClone}
            payto={
              isClone
                ? orderDetail?.orderData?.srt_pay_to_address
                : vendorDetails?.[`${prefix}_pay_to_address`]
            }
            shipto={
              isClone
                ? orderDetail?.orderData?.srt_ship_to_address
                : vendorDetails?.[`${prefix}_ship_to_address`]
            }
            pageType="sales return"
            page="add"
            type={type}
            orderDetail={orderDetail?.itemData}
            vendorDetails={
              isClone
                ? [orderDetail?.orderData]
                : [
                    {
                      ...vendorDetails,
                      srt_sub_total: orderData?.sub_total,
                      srt_total_gst: orderData?.total_tax,
                      srt_total_discount: orderData?.total_discount,
                      srt_total_amount: orderData?.total_amount,
                      srt_round_off_value: orderData?.round_off_value,
                      srt_tcs_or_tds_amount: orderData?.tcs_or_tds_amount,
                      srt_tcs_or_tds_percentage_id:
                        orderData?.tcs_or_tds_percentage_id,
                      srt_tcs_or_tds_percentage:
                        orderData?.tcs_or_tds_percentage,
                      srt_tds_tcs_type: orderData?.tcs_or_tds_type,
                      srt_is_invoice_dis_percentage:
                        orderData?.is_invoice_dis_percentage ?? true,
                      srt_invoice_discount: orderData?.invoice_discount ?? 0,
                      srt_invoice_discount_percentage:
                        orderData?.invoice_discount_percentage ?? 0,
                    },
                  ]
            }
          />
        </InnerLayout>
      )}
    </>
  );
};
export default AddSalesReturn;
